module.exports = require('./helpers/bundle-url').getBundleURL('9rAa3') + "atlaslogo.5491d009.svg";